import Header from '../components/global/header'
import Main from '../components/home/main'
import Footer from '../components/global/footer'

function Home() {
    return (
  <>
    <Header/>
    <Main showHero showCategoryFilter showBackToCalculators excludeCategories={[]} />
    <Footer/>
  </>
    );
  }
  
  export default Home;
  